// /app/frontend/src/components/frugal-v2/constants/colors.js
// Color constants for Frugal v2 (120 lines)

export const COLORS = {
  // Background gradient
  bgGradient: 'bg-gradient-to-br from-emerald-900 via-slate-900 to-slate-900',
  
  // Section colors
  income: {
    text: 'text-emerald-400',
    bg: 'bg-emerald-500',
    bgLight: 'bg-emerald-500/10',
    border: 'border-emerald-500',
    hover: 'hover:bg-emerald-500/20'
  },
  savings: {
    text: 'text-sky-400',
    bg: 'bg-sky-500',
    bgLight: 'bg-sky-500/10',
    border: 'border-sky-500',
    hover: 'hover:bg-sky-500/20'
  },
  reserves: {
    text: 'text-amber-400',
    bg: 'bg-amber-500',
    bgLight: 'bg-amber-500/10',
    border: 'border-amber-500',
    hover: 'hover:bg-amber-500/20'
  },
  expenses: {
    text: 'text-rose-400',
    bg: 'bg-rose-500',
    bgLight: 'bg-rose-500/10',
    border: 'border-rose-500',
    hover: 'hover:bg-rose-500/20'
  },
  
  // Status colors
  paid: 'bg-emerald-500/10 opacity-60',
  pending: 'bg-white/5',
  overdue: 'bg-red-500/20',
  
  // Text
  textPrimary: 'text-white',
  textSecondary: 'text-slate-400',
  textMuted: 'text-slate-500',
  
  // Borders
  borderLight: 'border-white/10',
  borderMedium: 'border-white/20',
  
  // Inputs
  input: 'bg-white/10 border border-white/20 text-white text-sm rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500',
  
  // Buttons
  btnPrimary: 'bg-emerald-500 hover:bg-emerald-600 text-white',
  btnSecondary: 'text-slate-400 hover:text-white hover:bg-white/10',
  btnDanger: 'text-rose-400 hover:bg-rose-500/20'
};

// Status badge colors based on days until due
export const getStatusColor = (daysUntil, isPaid) => {
  if (isPaid) return 'text-slate-500 bg-slate-700/50';
  if (daysUntil < -1) return 'text-white bg-red-600 font-bold';
  if (daysUntil < 0) return 'text-white bg-red-500 font-bold';
  if (daysUntil === 0) return 'text-white bg-amber-500 font-semibold';
  if (daysUntil <= 3) return 'text-white bg-amber-500 font-semibold';
  if (daysUntil <= 7) return 'text-white bg-emerald-500';
  return 'text-slate-400 bg-slate-700/50';
};

// Budget execution status colors - receives percent (0-100+)
export const getBudgetStatusColor = (percent) => {
  // Returns tailwind classes for bg, bar, and text based on spending percentage
  if (percent > 100) {
    return {
      bg: 'bg-red-500/10',
      bar: 'bg-red-500',
      text: 'text-red-400'
    };
  }
  if (percent === 100) {
    return {
      bg: 'bg-white/5',
      bar: 'bg-white',
      text: 'text-white'
    };
  }
  if (percent >= 75) {
    return {
      bg: 'bg-amber-500/10',
      bar: 'bg-amber-500',
      text: 'text-amber-400'
    };
  }
  // Normal - green (< 75%)
  return {
    bg: 'bg-emerald-500/10',
    bar: 'bg-emerald-500',
    text: 'text-emerald-400'
  };
};

export const CATEGORY_COLORS = {
  // Expense categories
  'Comunicacion': '#8B5CF6',
  'Deudas': '#F97316',
  'Impuestos': '#6B7280',
  'Seguros': '#14B8A6',
  'Vivienda': '#8B5CF6',
  'Educacion': '#EC4899',
  'Hogar': '#A855F7',
  'Servicios': '#F59E0B',
  'Vestimenta Necesaria': '#84CC16',
  'Alimentacion': '#10B981',
  'Salud': '#EF4444',
  'Transporte/Mantenimiento': '#3B82F6',
  'Caprichos': '#F472B6',
  'Entretenimiento': '#06B6D4',
  'Gastos Hormiga': '#FBBF24',
  'Mascotas': '#A78BFA',
  'Ocasionales': '#FB923C',
  'Ocio y Vicios': '#E879F9',
  'Ocio/Hobbies': '#22D3EE',
  'Regalos/Donaciones': '#F87171',
  'Restaurante/Bar': '#4ADE80',
  'Suscripciones': '#60A5FA',
  'Tarjeta de credito': '#F43F5E',
  'Cargos Bancarios': '#94A3B8',
  'Intereses': '#FB7185',
  // Income categories
  'Salario': '#10B981',
  'Inversiones': '#3B82F6',
  'Freelance': '#8B5CF6',
  // Savings categories
  'Ahorro Fondo Emergencia': '#06B6D4',
  'Ahorro Metas': '#14B8A6',
  // Default
  'Otros': '#6B7280'
};

export default COLORS;
